module.exports = __webpack_public_path__ + "static/media/home-category-1.cbd28199.png";